import { render, staticRenderFns } from "./BoPassRecover.vue?vue&type=template&id=f6d6b508&"
import script from "./BoPassRecover.vue?vue&type=script&lang=js&"
export * from "./BoPassRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports